import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import {connect} from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactDOM from 'react-dom';


//var termArr = [];
class ProfileEducation extends React.Component {
    constructor(props) {
        super(props);

        var d = new Date();
        var y = d.getFullYear();
        var enrollOptions = this.generateOptions(2010, y + 4);
        var graduateOptions = this.generateOptions(2010, y + 4);
        var mOps = [
            {value: 'Jan', label: 'Jan'},
            {value: 'Feb', label: 'Feb'},
            {value: 'Mar', label: 'Mar'},
            {value: 'Apr', label: 'Apr'},
            {value: 'May', label: 'May'},
            {value: 'Jun', label: 'Jun'},
            {value: 'Jul', label: 'Jul'},
            {value: 'Aug', label: 'Aug'},
            {value: 'Sep', label: 'Sep'},
            {value: 'Oct', label: 'Oct'},
            {value: 'Nov', label: 'Nov'},
            {value: 'Dec', label: 'Dec'}
        ];
        var my = false;
        if (this.props.user.id_account == this.props.profileId) {
            my = true;
        }
        this.state = {
            loading: false,
            profileId: this.props.profileId,
            my: my,
            eduArr: [],
            edus: [],
            show: false,
            mOps: mOps,
            degOps: [],
            majorOptions: [],
            enOps: enrollOptions,
            graOps: graduateOptions,
            pUni: {},
            item: {}
        };
        //profileId = this.props.profileId;
        //this.getCourses = this.getCourses.bind(this);
    }

    generateOptions(from, to) {
        var options = [];
        for (var i = from; i <= to; i++) {
            options.push({value: i.toString(), label: i.toString()});
        }

        return options.slice();
    }

    getDateFromString(mon, year) {
        return new Date(Date.parse(mon + " 1, " + year));
    }

    monthDiff(d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months + 1;
    }


    componentDidMount() {
        this.setState({loading: true}, () => {
            this.getPrimaryEdu();
            this.getEdus();
        });

        axios.get(commonApi.getAPIURL() + '?api=getDegrees')
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({degOps: response.data.data});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
        axios.get('code/apis.php?api=searchMMajor&search=')
            .then(response => {
                if (response.data.status == 1) {
                    //vamajorOptions = response.data.data;
                    var majorOptions = response.data.data;
                    majorOptions.unshift({value: "0", label: "Not Declared"});
                    this.setState({majorOptions: majorOptions});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });

    }

    componentWillReceiveProps(nextProps) {
        var my = nextProps.my;
        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({
                loading: loading,
                profileId: nextProps.profileId,
                my: my,
                eduArr: [],
                edus: [],
                pUni: {}
            }, () => {
                this.getPrimaryEdu();
                this.getEdus();
            });
        }
        else {
            this.setState({profileId: nextProps.profileId, my: my});
        }


        //profileId = nextProps.profileId;
        //this.getCourses();
    }

    getPrimaryEdu() {
        axios.get(commonApi.getAPIURL() + '?api=getPrimaryEdu&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({pUni: response.data.data});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);

                return response;
            });
    }

    getEdus() {
        axios.get(commonApi.getAPIURL() + '?api=getEdus&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {

                    var eduArr = [];

                    for (var item of response.data.data) {


                        var uni_avatar = item.name.substring(0, 1).toUpperCase();
                        if (item.id_file > 0) {
                            uni_avatar = (<img src={item.file.link_file}/>);
                        }

                        eduArr.push(<div key={"edu-item-" + item.id} className="item_box">
                            <div className="left_item_box">
                                <div className="image">
                                    {uni_avatar}
                                </div>
                            </div>
                            <div className="right_item_box">
                                <div className="title">{item.name} </div>
                                {item.degree != undefined ? (<div className="des">{item.degree}</div>) : ""}

                                <div
                                    className="des">{item.menroll} {item.enroll} - {item.mgraduate} {item.graduate}</div>
                                {item.major != undefined ? (
                                    <div className="des"><b>Major</b> in {item.major}</div>) : ""}
                                {item.minor != undefined ? (
                                    <div className="des"><b>Minor</b> in {item.minor}</div>) : ""}
                                {item.hdgpa != 1 ? (
                                    <div className="des"><b>Department GPA: {parseFloat(item.dgpa).toFixed(1)}</b>
                                    </div>) : ""}
                                {item.hcgpa != 1 ? (
                                    <div className="des"><b>Cumulative GPA: {parseFloat(item.cgpa).toFixed(1)}</b>
                                    </div>) : ""}
                                {this.state.my ? (
                                    <div><a onClick={this.removeEdu.bind(this, item)} className="close_btn"><img
                                        src="/static/img/appimg/icon_close_x.png"/></a>
                                        <a onClick={this.editEdu.bind(this, item)} className="edit_btn"><img
                                            src="/static/img/appimg/email-icon03.png"/></a></div>) : ""}
                            </div>
                        </div>);

                    }

                    this.setState({edus: response.data.data, eduArr: eduArr});
                    //store.dispatch(getUserSuccess(response.data.data));
                }
                //console.log(response.data);
                this.setState({loading: false});
                return response;
            });
    }


    optionRenderer(option) {
        var img = option.label.substring(0, 1).toUpperCase();
        if (option.icon != "") {
            img = (<img src={option.icon}/>);
        }
        return (<div className="option_item">
            <div className="option_img">
                {img}
            </div>
            <div className="option_label">
                <span className="name">{option.label}</span><br/>
                <span className="des">{option.des}</span>
            </div>
        </div>);
    }

    getOptions(input, callback) {
        if (input.length < 2) {
            //this.setState({notext:"Enter at least 3 characters"})

            //this.setState({placeholder:remain});
            callback(null, {options: []});
            return;
        }
        this.setState({notext: "No results found"})
        var data = new FormData();

        data.append('search', input);


        axios.post(commonApi.getAPIURL() + '?api=searchSchool', data, {
            progress: (progressEvent) => {

            }
        })
            .then(response => {
                if (response.data.status == 1) {
                    var array = [];
                    var i = 1;
                    for (var item of response.data.data) {
                        var name = item.name_university;

                        var img = '';
                        if (item.id_file_university > 0) {
                            img = item.file.link_file;
                        }
                        var des = item.city_university + ", " + item.state_university;
                        array.push({value: item.id_university, label: name, des: des, icon: img});
                        i++;
                    }

                    callback(null, {options: array});
                }
                else {
                    callback(null, {options: []});
                }
                //console.log(response.data);

                return response;
            }).catch(error => {
            callback(null, {options: []});
        });


        //console.log(callback);

        //return testop;
    }

    onSelectSchool(item) {
        var it = this.state.item;
        if (item.icon != "") {
            it.img = (<img src={item.icon}/>);
        }
        else {
            it.img = item.label.substring(0, 1).toUpperCase();
        }
        it.sid = item.value;
        this.setState({item: it});
    }

    onSelectDegree(item) {
        var it = this.state.item;

        it.degree = item.value;
        this.setState({item: it});
    }

    onSelectMEnroll(item) {
        var it = this.state.item;

        it.menroll = item.value;
        this.setState({item: it});
    }

    onSelectEnroll(item) {
        var it = this.state.item;

        it.enroll = item.value;
        this.setState({item: it});
    }

    onSelectMGra(item) {
        var it = this.state.item;

        it.mgraduate = item.value;
        this.setState({item: it});
    }

    onSelectGra(item) {
        var it = this.state.item;

        it.graduate = item.value;
        this.setState({item: it});
    }

    onSelectMajor(item) {
        var it = this.state.item;

        it.major = item.value;
        this.setState({item: it});
    }

    onSelectMinor(item) {
        var it = this.state.item;

        it.minor = item.value;
        this.setState({item: it});
    }

    onHDGPAClick(e) {
        var it = this.state.item;
        if (it.hdgpa == undefined) {
            it.hdgpa = true;
        }
        else {
            it.hdgpa = !it.hdgpa;
        }
        //var val = !this.state.paid;
        this.setState({item: it});

    }

    onHCGPAClick(e) {
        var it = this.state.item;
        if (it.hcgpa == undefined) {
            it.hcgpa = true;
        }
        else {
            it.hcgpa = !it.hcgpa;
        }
        //var val = !this.state.paid;
        this.setState({item: it});

    }

    onDGPAChange(e) {
        var it = this.state.item;
        it.dgpa = e.target.value;
        this.setState({item: it});
    }

    onCGPAChange(e) {
        var it = this.state.item;
        it.cgpa = e.target.value;
        this.setState({item: it});
    }

    addClick(e) {
        this.setState({show: true, item: {}})
    }

    save(e) {
        var item = this.state.item;
        if (item.sid == undefined) {
            commonApi.showAlert("Please select your school");
            return;
        }
        if (item.degree == undefined) {
            commonApi.showAlert("Please select your degree");
            return;
        }
        if (item.menroll == undefined || item.enroll == undefined || item.mgraduate == undefined || item.graduate == undefined) {
            commonApi.showAlert("Please select your time period");
            return;
        }
        if (item.major == undefined) {
            commonApi.showAlert("Please select your major");
            return;
        }
        if (item.minor == undefined) {
            item.minor = 0;
            //return;
        }
        if (item.dgpa == undefined) {
            item.dgpa = 0;
            //return;
        }
        if (item.cgpa == undefined) {
            item.cgpa = 0;
            //return;
        }
        if (item.hdgpa == undefined) {
            item.hdgpa = 0;
            //return;
        }
        if (item.hcgpa == undefined) {
            item.hcgpa = 0;
            //return;
        }
        if (item.id == undefined) {
            item.id = 0;
            //return;
        }
        var d1 = this.getDateFromString(item.mstart, item.start);
        var d2 = this.getDateFromString(item.mend, item.end);

        var month = this.monthDiff(d1, d2);
        if (month <= 0) {
            commonApi.showAlert("Your time period not valid");
            return;
        }
        if (item.pri == undefined) {
            item.pri = 0;
            //return;
        }
        var data = new FormData();
        data.append('id', item.id);
        data.append('pri', item.pri);
        data.append('sid', item.sid);
        data.append('degree', item.degree);
        data.append('menroll', item.menroll);
        data.append('enroll', item.enroll);
        data.append('mgraduate', item.mgraduate);
        data.append('graduate', item.graduate);
        data.append('major', item.major);
        data.append('minor', item.minor);
        data.append('dgpa', item.dgpa);
        data.append('cgpa', item.cgpa);
        data.append('hdgpa', item.hdgpa);
        data.append('hcgpa', item.hcgpa);
        data.append('user_id', this.state.profileId);
        axios.post(commonApi.getAPIURL() + '?api=updateEducation', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});
                    if (item.pri == 1) {
                        this.getPrimaryEdu();
                    }
                    else {
                        this.getEdus();
                    }


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });

    }


    cancel(e) {
        this.setState({show: false, item: {}});
    }

    editPri(e) {
        var item = Object.assign({}, this.state.pUni);
        if (this.state.pUni.id_file > 0) {
            item.img = (<img src={this.state.pUni.file.link_file}/>);
        }
        else {
            item.img = this.state.pUni.name.substring(0, 1).toUpperCase();
        }
        item.pri = 1;
        item.major = this.state.pUni.id_major == undefined ? "0" : this.state.pUni.id_major;
        item.minor = this.state.pUni.id_minor == undefined ? "0" : this.state.pUni.id_minor;
        ;
        item.degree = this.state.pUni.id_degree;
        item.hdgpa = this.state.pUni.hdgpa == 0 ? false : true;
        item.hcgpa = this.state.pUni.hcgpa == 0 ? false : true;
        item.edit = true;
        this.setState({show: true, item: item});
    }

    editEdu(it, e) {
        var item = Object.assign({}, it);
        ;
        if (item.id_file > 0) {
            item.img = (<img src={item.file.link_file}/>);
        }
        else {
            item.img = item.name.substring(0, 1).toUpperCase();
        }
        item.pri = 0;
        item.major = item.id_major == undefined ? "0" : item.id_major;
        item.minor = item.id_minor == undefined ? "0" : item.id_minor;
        ;
        item.degree = item.id_degree;
        item.hdgpa = item.hdgpa == 0 ? false : true;
        item.hcgpa = item.hcgpa == 0 ? false : true;
        item.edit = true;
        this.setState({show: true, item: item});
        window.scrollTo(0, 0);
    }

    removeEdu(it, e) {
        var data = new FormData();
        data.append('id', it.id);

        axios.post(commonApi.getAPIURL() + '?api=removeEducation', data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({show: false, item: {}});

                    this.getEdus();


                }

                //console.log(response.data);

                return response;
            }).catch(error => {

        });
    }

    getMMajorOptions(input, callback) {
        if(input.length == 0)
        {
            this.setState({majorOptions:this.state.majorOptions});
        }
        else {
            var data = new FormData();
            data.append('search', input);
            axios.post('/code/apis.php?api=searchMMajor', data, {
                progress: (progressEvent) => {}
            })
                .then(response => {
                    if (response.data.status == 1) {
                        this.setState({majorOptions: response.data.data});
                    } else {
                        this.setState({majorOptions:[]});
                    }
                    return response;
                })
                .catch(error => {
                    callback(null, { options: [] });
                });
        }
    }

    render() {
        // if(this.state.terms == undefined){
        // return (
        // <div className="page_course_box profile_content_wrapper">
        // <div >
        // <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width="20px" height="20px" /> Loading</div>
        // </div>
// 					
        // </div>
        // );
        // }
        var uni_avatar = "";
        if (Object.keys(this.state.pUni).length > 0) {
            uni_avatar = this.state.pUni.name.substring(0, 1).toUpperCase();
            if (this.state.pUni.id_file > 0) {
                uni_avatar = (<img src={this.state.pUni.file.link_file}/>);
            }
        }

        return (
            <div className="page_course_box profile_content_wrapper">
                <div className="title_box">
                    <img src="/static/img/appimg/icon_school.png"/>
                    <div className="title">
                        Education
                    </div>
                </div>
                {this.state.show ? (<div className="edit_box">
                    <div className="left_edit_box">
                        <div className="image">
                            {this.state.item.img}
                        </div>
                    </div>
                    <div className="right_edit_box">
                        <div className="edit_item">
                            <div className="title">School Name</div>
                            <div>{this.state.item.edit ? (
                                <input className="input_text" type="text" value={this.state.item.name}/>) : (
                                <Select.Async
                                    name="form-field-name"
                                    value={this.state.item.sid}
                                    disabled={this.state.item.edit}
                                    optionRenderer={this.optionRenderer}
                                    onChange={this.onSelectSchool.bind(this)}
                                    placeholder="Start typing to find your school"
                                    loadOptions={this.getOptions.bind(this)}
                                    noResultsText="No school found"
                                    searchPromptText="Enter at least 2 charactors"
                                />)}</div>


                        </div>
                        <div className="edit_item">
                            <div className="title">Expected Degree</div>
                            <div><Select
                                value={this.state.item.degree}
                                onChange={this.onSelectDegree.bind(this)}
                                placeholder=""
                                options={this.state.degOps}
                                clearable={false}
                                searchable={false}
                            /></div>


                        </div>
                        <div className="edit_item inline_block">
                            <div className="title">Time Period</div>
                            <div className="div_50" style={{paddingRight: "10px"}}>
                                <div>Start Date</div>
                                <div className="inline_block">
                                    <div className="div_50" style={{paddingRight: "5px"}}>
                                        <Select
                                            value={this.state.item.menroll}
                                            onChange={this.onSelectMEnroll.bind(this)}
                                            placeholder=""
                                            options={this.state.mOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                    <div className="div_50">
                                        <Select
                                            value={this.state.item.enroll}
                                            onChange={this.onSelectEnroll.bind(this)}
                                            placeholder=""
                                            options={this.state.enOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="div_50" style={{paddingLeft: "10px"}}>
                                <div>End Date</div>
                                <div className="inline_block">
                                    <div className="div_50" style={{paddingRight: "5px"}}>
                                        <Select
                                            value={this.state.item.mgraduate}
                                            onChange={this.onSelectMGra.bind(this)}
                                            placeholder=""
                                            options={this.state.mOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                    <div className="div_50">
                                        <Select
                                            value={this.state.item.graduate}
                                            onChange={this.onSelectGra.bind(this)}
                                            placeholder=""
                                            options={this.state.graOps}
                                            clearable={false}
                                            searchable={false}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="edit_item">
                            <div className="title">Major</div>
                            <div><Select
                                placeholder="Type or select any major to add it to your profile"
                                value={this.state.item.major}
                                options={this.state.majorOptions}
                                onChange={this.onSelectMajor.bind(this)}
                                onInputChange={this.getMMajorOptions.bind(this)}
                                clearable={false}
                                searchable={true}
                            /></div>


                        </div>
                        <div className="edit_item">
                            <div className="title">Minor</div>
                            <div><Select
                                value={this.state.item.minor}
                                onChange={this.onSelectMinor.bind(this)}
                                placeholder="Type or select any minor to add it to your profile"
                                options={this.state.majorOptions}
                                clearable={false}
                                searchable={true}
                            /></div>


                        </div>
                        <div className="edit_item inline_block">
                            <div className="div_50" style={{paddingRight: "10px"}}>
                                <div className="title">Department GPA <label className="checkbox-inline fright"><input
                                    type="checkbox" value="" onClick={this.onHDGPAClick.bind(this)}
                                    checked={this.state.item.hdgpa}/>hide on profile</label></div>
                                <div>
                                    <input onChange={this.onDGPAChange.bind(this)} className="input_text" type="text"
                                           placeholder="" value={this.state.item.dgpa}/>
                                </div>
                                <div className="des">GPA is on a 4-point scale.</div>
                            </div>
                            <div className="div_50" style={{paddingLeft: "10px"}}>
                                <div className="title">Cumulative GPA <label className="checkbox-inline fright"><input
                                    type="checkbox" value="" onClick={this.onHCGPAClick.bind(this)}
                                    checked={this.state.item.hcgpa}/>hide on profile</label></div>
                                <div>
                                    <input onChange={this.onCGPAChange.bind(this)} className="input_text" type="text"
                                           placeholder="" value={this.state.item.cgpa}/>
                                </div>
                                <div className="des">GPA is on a 4-point scale.</div>
                            </div>
                        </div>
                        <div className="edit_item">
                            <div className="title"></div>
                            <a onClick={this.save.bind(this)} className="btn_v btn_confirm fright">Save</a>
                            <a onClick={this.cancel.bind(this)} style={{marginRight: "10px"}}
                               className="btn_v btn_cancel fright">Cancel</a>

                        </div>
                    </div>
                </div>) : (
                    <div className={this.state.my ? "add_box clickable" : "hide-el"} onClick={this.addClick.bind(this)}>
                        <div className="left_add_box">
                            <img src="/static/img/appimg/icon_add_black.png"/>
                        </div>
                        <div className="right_add_box">
                            <div className="title">Add your schools, major, and GPA</div>
                            <div className="des"><img src="/static/img/appimg/icon_i.png"/> you can find an example below
                            </div>
                        </div>
                    </div>)}

                <div className={Object.keys(this.state.pUni).length > 0 ? "item_box" : "hide-el"}
                     style={{border: "none"}}>
                    <div className="left_item_box">
                        <div className="image">
                            {uni_avatar}
                        </div>
                    </div>
                    <div className="right_item_box">
                        <div className="title">{this.state.pUni.name}
                            <div className="primary_tag">primary education</div>
                        </div>
                        {this.state.pUni.degree != undefined ? (
                            <div className="des">{this.state.pUni.degree}</div>) : ""}

                        <div
                            className="des">{this.state.pUni.menroll} {this.state.pUni.enroll} - {this.state.pUni.mgraduate} {this.state.pUni.graduate}</div>
                        {this.state.pUni.major != undefined ? (
                            <div className="des"><b>Major</b> in {this.state.pUni.major}</div>) : ""}
                        {this.state.pUni.minor != undefined ? (
                            <div className="des"><b>Minor</b> in {this.state.pUni.minor}</div>) : ""}
                        {this.state.pUni.hdgpa != 1 ? (
                            <div className="des"><b>Department GPA: {parseFloat(this.state.pUni.dgpa).toFixed(1)}</b>
                            </div>) : ""}
                        {this.state.pUni.hcgpa != 1 ? (
                            <div className="des"><b>Cumulative GPA: {parseFloat(this.state.pUni.cgpa).toFixed(1)}</b>
                            </div>) : ""}
                        {this.state.my ? (
                            <div><a className="close_btn hide-el"><img src="/static/img/appimg/icon_close_x.png"/></a>
                                <a onClick={this.editPri.bind(this)} className="edit_btn"><img
                                    src="/static/img/appimg/email-icon03.png"/></a></div>) : ""}
                    </div>
                </div>
                <div className={this.state.loading == false ? "" : "hide-el"}>
                    {this.state.eduArr}
                </div>


            </div>

        )
    }
}

export default ProfileEducation;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_education.js
 **/